module.exports = __webpack_public_path__ + "assets/img/Logo-Enlight.1e69c782.png";